import React, { useEffect } from "react";
import Header from "./header";
import Footer from "./footer";
import { CustomLayoutProps } from "../../interfaces/customLayout";
import ScrollToTop from "../../router/scrollToTop";
import { ToastContainer } from "react-toastify";
import Loader from "../../connected-components/loader";
import EnquireModal from "../../connected-components/enquireModal/index";
import { getConfig } from "../content/home/actions";

const CustomLayout: React.FC<CustomLayoutProps> = ({ children }) => {
  useEffect(() => {
    getConfig();
  }, []);

  return (
    <div>
      <ScrollToTop />
      <ToastContainer
        position="bottom-left"
        toastClassName="!bg-gray-800 !backdrop-blur-[20px] !text-white !border !border-gray-700 !rounded-xl"
      />
      <Header />
      {children}
      <Footer />
      <Loader />
      <EnquireModal />
    </div>
  );
};

export default CustomLayout;
